import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UiEventRaised } from '@cmx/shared/feature/platform-configuration';
import { Curves, getRandomColor } from '../charts.utils';
import { Axis, Dimensions, Legend, MultiSeriesDataWithRange } from '../charts.model';
import { FieldType } from '@ngx-formly/core';
@Component({
  selector: 'cmx-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent extends FieldType implements OnInit {
  @Input() data: MultiSeriesDataWithRange[] = [];

  @Input() dimensions: Dimensions = { width: '', height: '' };
  @Input() allowResize = false;
  @Input() legend: Legend = {
    visible: true,
    title: 'Legend',
    position: 'right' || 'below',
  };
  @Input() axis: Axis = {
    showXAxis: true,
    showYAxis: true,
    xAxisLabel: 'xAxis',
    yAxisLabel: 'yAxis',
    showXAxisLabel: true,
    showYAxisLabel: false,
  };
  @Input() enableAnimations = true;
  @Input() showGridLines = true;
  @Input() timeline = true;
  @Input() schemeType = 'ordinal' || 'linear';
  @Input() tooltipDisabled = false;
  @Input() itemColor: string[] = [];
  @Input() curveType = 'linear';
  @Input() isFormlyField = true;

  @Output() raiseLineChartEvent = new EventEmitter<UiEventRaised>();

  colorScheme: { domain: string[] } = { domain: [] };
  curve = Curves[this.curveType];
  view: [number, number] = [500, 300];

  constructor(private element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.isFormlyField) {
      this.data = this.to.data || this.data;
      this.allowResize = this.to.allowResize || this.allowResize;

      this.dimensions = this.to.dimensions || this.dimensions;
      this.axis = this.to.axis || this.axis;
      this.legend = this.to.legend || this.legend;
      this.enableAnimations = this.to.enableAnimations || this.enableAnimations;
      this.tooltipDisabled = this.to.tooltipDisabled || this.tooltipDisabled;
      this.curveType = this.to.curveType || this.curveType;
      this.itemColor = this.to.itemColor || this.itemColor;
      this.schemeType = this.to.schemeType || this.schemeType;
      this.timeline = this.to.timeline || this.timeline;
      this.showGridLines = this.to.showGridLines || this.showGridLines;
    }
    this.resize(this.dimensions.width, this.dimensions.height);
    this.applyColors();
  }

  applyColors() {
    if (this.itemColor && !this.itemColor.length) {
      this.data.forEach(() => {
        this.colorScheme.domain.push(getRandomColor());
      });
    } else this.colorScheme.domain = this.itemColor;
  }

  onSelect(data: unknown): void {
    this.raiseEvent('line-chart-clicked', data, false);
  }

  raiseEvent(eventName: string, data: unknown, isNavigation: boolean): void {
    const eventToRaise: UiEventRaised = { eventName, data, isNavigation };
    if (this.isFormlyField) {
      this.to.getFieldEvent(eventToRaise);
    } else {
      this.raiseLineChartEvent.emit(eventToRaise);
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.resize(undefined, this.dimensions.height);
  }

  resize(width?: string | number, height?: string | number, timeout = 0) {
    setTimeout(() => {
      const parentElement = this.element.nativeElement.parentElement.parentElement;
      if (parentElement) {
        this.view = [+(width || parentElement.offsetWidth - 30), +(height || parentElement.offsetHeight)];
      }
    }, timeout);
  }
}
